import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';

export const getAudioQueueIndex = ({
  queue,
  audioGuid,
  playlistAudioGuid,
}: {
  queue: AudioPlayerAudioInstance[];
  audioGuid: string;
  playlistAudioGuid?: string;
}) => {
  return queue.findIndex((queueAudio) => {
    if (playlistAudioGuid) {
      return queueAudio.playlistAudioGuid === playlistAudioGuid;
    }
    return queueAudio.audioGuid === audioGuid;
  });
};
